import {iconUrl} from 'data/icon'
import {Attribute} from 'event'
import {BonusModifier, ensureActions} from '../type'

export const DRK = ensureActions({
	HARD_SLASH: {
		id: 3617,
		name: 'Hard Slash',
		icon: iconUrl(3051),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		combo: {
			start: true,
		},
		potencies: [{
			value: 260,
			bonusModifiers: [],
		}],
	},
	SYPHON_STRIKE: {
		id: 3623,
		name: 'Syphon Strike',
		icon: iconUrl(3054),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		combo: {
			from: 3617,
		},
		potencies: [{
			value: 220,
			bonusModifiers: [],
		},
		{
			value: 360,
			bonusModifiers: [BonusModifier.COMBO],
		}],
	},
	UNLEASH: {
		id: 3621,
		name: 'Unleash',
		icon: iconUrl(3063),
		onGcd: true,
		speedAttribute: Attribute.SPELL_SPEED,
		combo: {
			start: true,
		},
		potencies: [{
			value: 120,
			bonusModifiers: [],
		}],
	},
	GRIT: {
		id: 3629,
		name: 'Grit',
		icon: iconUrl(3070),
		cooldown: 2000,
	},
	RELEASE_GRIT: {
		id: 32067,
		name: 'Release Grit',
		icon: iconUrl(3092),
		onGcd: false,
		cooldown: 1000,
	},
	UNMEND: {
		id: 3624,
		name: 'Unmend',
		icon: iconUrl(3062),
		onGcd: true,
		speedAttribute: Attribute.SPELL_SPEED,
		breaksCombo: false,
	},
	SOULEATER: {
		id: 3632,
		name: 'Souleater',
		icon: iconUrl(3055),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		combo: {
			from: 3623,
			end: true,
		},
		potencies: [{
			value: 240,
			bonusModifiers: [],
		},
		{
			value: 460,
			bonusModifiers: [BonusModifier.COMBO],
		}],
	},
	BLOOD_WEAPON: {
		id: 3625,
		name: 'Blood Weapon',
		icon: iconUrl(3071),
		cooldown: 60000,
		//statusesApplied: ['BLOOD_WEAPON'],  // Removing this until we have better level sync support, as Blood Weapon upgrades to Delirium at 68 and then Delirium applies both statuses
	},
	SHADOW_WALL: {
		id: 3636,
		name: 'Shadow Wall',
		icon: iconUrl(3075),
		cooldown: 120000,
		statusesApplied: ['SHADOW_WALL'],
	},
	STALWART_SOUL: {
		id: 16468,
		name: 'Stalwart Soul',
		icon: iconUrl(3084),
		onGcd: true,
		speedAttribute: Attribute.SPELL_SPEED,
		combo: {
			from: 3621,
			end: true,
		},
		potencies: [{
			value: 120,
			bonusModifiers: [],
		},
		{
			value: 160,
			bonusModifiers: [BonusModifier.COMBO],
		}],
	},
	DARK_MIND: {
		id: 3634,
		name: 'Dark Mind',
		icon: iconUrl(3076),
		cooldown: 60000,
		statusesApplied: ['DARK_MIND'],
	},
	LIVING_DEAD: {
		id: 3638,
		name: 'Living Dead',
		icon: iconUrl(3077),
		cooldown: 300000,
		statusesApplied: ['LIVING_DEAD', 'WALKING_DEAD'],
	},
	SALTED_EARTH: {
		id: 3639,
		name: 'Salted Earth',
		icon: iconUrl(3066),
		cooldown: 90000,
		statusesApplied: ['SALTED_EARTH'],
	},
	SHADOWSTRIDE: {
		id: 36926,
		name: 'Shadowstride',
		icon: iconUrl(3093),
		cooldown: 30000,
		charges: 2,
	},
	ABYSSAL_DRAIN: {
		id: 3641,
		name: 'Abyssal Drain',
		icon: iconUrl(3064),
		cooldown: 60000,
		cooldownGroup: 14,
		potencies: [{
			value: 240,
			bonusModifiers: [],
		}],
	},
	CARVE_AND_SPIT: {
		id: 3643,
		name: 'Carve and Spit',
		icon: iconUrl(3058),
		cooldown: 60000,
		cooldownGroup: 14,
		potencies: [{
			value: 510,
			bonusModifiers: [],
		}],
	},
	BLOODSPILLER: {
		id: 7392,
		name: 'Bloodspiller',
		icon: iconUrl(3080),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		breaksCombo: false,
		potencies: [{
			value: 600,
			bonusModifiers: [],
		}],
	},
	QUIETUS: {
		id: 7391,
		name: 'Quietus',
		icon: iconUrl(3079),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		breaksCombo: false,
		potencies: [{
			value: 240,
			bonusModifiers: [],
		}],
	},
	DELIRIUM: {
		id: 7390,
		name: 'Delirium',
		icon: iconUrl(3078),
		cooldown: 60000,
		statusesApplied: ['DELIRIUM', 'BLOOD_WEAPON'],
	},
	THE_BLACKEST_NIGHT: {
		id: 7393,
		name: 'The Blackest Night',
		icon: iconUrl(3081),
		cooldown: 15000,
		statusesApplied: ['BLACKEST_NIGHT'],
	},
	FLOOD_OF_SHADOW: {
		id: 16469,
		name: 'Flood of Shadow',
		icon: iconUrl(3085),
		cooldown: 1000,
		potencies: [{
			value: 100,
			bonusModifiers: [],
		}],
	},
	EDGE_OF_SHADOW: {
		id: 16470,
		name: 'Edge of Shadow',
		icon: iconUrl(3086),
		cooldown: 1000,
		potencies: [{
			value: 300,
			bonusModifiers: [],
		}],
	},
	DARK_MISSIONARY: {
		id: 16471,
		name: 'Dark Missionary',
		icon: iconUrl(3087),
		cooldown: 90000,
		statusesApplied: ['DARK_MISSIONARY'],
	},
	LIVING_SHADOW: {
		id: 16472,
		name: 'Living Shadow',
		icon: iconUrl(3088),
		cooldown: 120000,
	},
	OBLATION: {
		id: 25754,
		name: 'Oblation',
		icon: iconUrl(3089),
		cooldown: 60000,
		statusesApplied: ['OBLATION'],
		charges: 2,
	},
	SALT_AND_DARKNESS: {
		id: 25755,
		name: 'Salt and Darkness',
		icon: iconUrl(3090),
		cooldown: 20000,
	},
	SALT_AND_DARKNESS_DAMAGE: {
		id: 25756,
		name: 'Salt and Darkness',
		icon: iconUrl(3090),
		cooldown: 20000,
	},
	SHADOWBRINGER: {
		id: 25757,
		name: 'Shadowbringer',
		icon: iconUrl(3091),
		cooldown: 60000,
		charges: 2,
	},
	SHADOWED_VIGIL: {
		id: 36927,
		name: 'Shadowed Vigil',
		icon: iconUrl(3094),
		cooldown: 120000,
	},
	SCARLET_DELIRIUM: {
		id: 36928,
		name: 'Scarlet Delirium',
		icon: iconUrl(3095),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		breaksCombo: false,
		potencies: [{
			value: 620,
			bonusModifiers: [],
		}],
	},
	COMEUPPANCE: {
		id: 36929,
		name: 'Comeuppance',
		icon: iconUrl(3096),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		breaksCombo: false,
		potencies: [{
			value: 720,
			bonusModifiers: [],
		}],
	},
	TORCLEAVER: {
		id: 36930,
		name: 'Torcleaver',
		icon: iconUrl(3097),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		breaksCombo: false,
		potencies: [{
			value: 820,
			bonusModifiers: [],
		}],
	},
	IMPALEMENT: {
		id: 36931,
		name: 'Impalement',
		icon: iconUrl(3098),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		breaksCombo: false,
		potencies: [{
			value: 320,
			bonusModifiers: [],
		}],
	},
	DISESTEEM: {
		id: 36932,
		name: 'Disesteem',
		icon: iconUrl(3099),
		onGcd: true,
		speedAttribute: Attribute.SKILL_SPEED,
		breaksCombo: false,
		potencies: [{
			value: 800,
			bonusModifiers: [],
		}],
	},
	// Esteem
	ESTEEM_ABYSSAL_DRAIN: {
		id: 17904,
		name: 'Abyssal Drain',
		icon: iconUrl(3064),
	},
	ESTEEM_BLOODSPILLER: {
		id: 17909,
		name: 'Bloodspiller',
		icon: iconUrl(3080),
	},
	ESTEEM_EDGE_OF_SHADOW: {
		id: 17908,
		name: 'Edge of Shadow',
		icon: iconUrl(3086),
	},
	ESTEEM_SHADOWSTRIDE: {
		id: 38512,
		name: 'Shadowstride',
		icon: iconUrl(3093),
	},
	ESTEEM_SHADOWBRINGER: {
		id: 25881,
		name: 'Shadowbringer',
		icon: iconUrl(3091),
	},
	ESTEEM_DISESTEEM: {
		id: 36933,
		name: 'Disesteem',
		icon: iconUrl(3099),
	},
})
